var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg2 = function Svg2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.535,
    y: 0.16,
    width: 21.752,
    height: 3.471,
    rx: 0.389,
    fill: "#DDD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.711,
    y: 4.893,
    width: 54.577,
    height: 2.209,
    rx: 0.389,
    fill: "#B3B3B3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.711,
    y: 8.049,
    width: 9.031,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.557,
    y: 8.049,
    width: 10.601,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.711,
    y: 11.521,
    width: 54.577,
    height: 2.209,
    rx: 0.389,
    fill: "#B3B3B3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.711,
    y: 14.678,
    width: 9.031,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 38.012,
    y: 14.678,
    width: 5.89,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 49.398,
    y: 14.678,
    width: 5.89,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0.711,
    y: 17.834,
    width: 54.577,
    height: 2.209,
    rx: 0.389,
    fill: "#B3B3B3"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0.711,
    y: 37.084,
    width: 54.577,
    height: 2.209,
    rx: 0.389,
    fill: "#B3B3B3"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 0.711,
    y: 20.99,
    width: 9.031,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 0.711,
    y: 40.24,
    width: 9.031,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 40.76,
    y: 20.99,
    width: 5.89,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 40.76,
    y: 40.24,
    width: 5.89,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 28.195,
    y: 20.99,
    width: 9.816,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 28.195,
    y: 40.24,
    width: 9.816,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 49.398,
    y: 20.99,
    width: 5.89,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 0.711,
    y: 24.461,
    width: 54.577,
    height: 2.209,
    rx: 0.389,
    fill: "#B3B3B3"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 49.398,
    y: 40.24,
    width: 5.89,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 0.711,
    y: 27.615,
    width: 9.031,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 11.705,
    y: 27.615,
    width: 3.141,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 17.201,
    y: 27.615,
    width: 3.141,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 22.699,
    y: 27.615,
    width: 3.141,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 40.76,
    y: 27.615,
    width: 5.89,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 40.76,
    y: 30.771,
    width: 5.89,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 14.453,
    y: 20.99,
    width: 9.816,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 40.76,
    y: 33.928,
    width: 5.89,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 28.195,
    y: 27.615,
    width: 9.816,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 28.195,
    y: 30.771,
    width: 9.816,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 28.195,
    y: 33.928,
    width: 9.816,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 49.398,
    y: 27.615,
    width: 5.89,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 14.453,
    y: 40.24,
    width: 9.816,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 49.398,
    y: 30.771,
    width: 5.89,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 49.398,
    y: 33.928,
    width: 5.89,
    height: 2.209,
    rx: 0.389,
    fill: "#DDD"
  })));
};

export default Svg2;